import { HugeiconsIcon, IconSvgElement } from '@hugeicons/react';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export interface NAvatarProps {
  size?: 'xs' | 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'tertiary' | 'outline' | 'transparent';
  hugeIcon?: IconSvgElement;
  text?: string;
  children?: ReactNode;
  className?: string;
}

const NAvatar = ({ text, color = 'primary', size = 'medium', hugeIcon, children, className }: NAvatarProps) => {

  const colorMap = {
    primary: 'bg-primary text-slate-900',
    secondary: 'bg-neutral-900 text-white',
    tertiary: 'bg-slate-200 text-slate-900',
    outline: 'text-slate-900 border border-slate-300',
    transparent: 'bg-transparent text-slate-900'
  };

  const sizeMap = {
    xs: 'w-6 h-6 text-xs',
    small: 'w-9 h-9',
    medium: 'w-11 h-11 text-base',
    large: 'w-13 h-13 text-lg '
  };

  const iconSize = {
    xs: 16,
    small: 20,
    medium: 20,
    large: 20
  };

  return (
    <div
      className={twMerge('flex items-center justify-center rounded-full font-medium flex-shrink-0 overflow-hidden', colorMap[color], sizeMap[size], className)}>
      {text && <p>{text?.slice(0, 1).toUpperCase()}</p>}
      {hugeIcon && <HugeiconsIcon size={iconSize[size]} strokeWidth={2} icon={hugeIcon} />}
      {children && children}
    </div>
  );
};
export default NAvatar;
